<template>
  <div>
    <div class="load-container" v-if="isLoading">
      <div class="spinner-container">
        <div class="wrapper">
          <div class="spinner-grow" role="status"></div>
          <div class="spinner-grow" role="status"></div>
          <div class="spinner-grow" role="status"></div>
        </div>

        <span style="color: #000; margin-bottom: 5px">{{ loadingText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
    loadingText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.load-container {
  background: rgba($color: #fff, $alpha: 1);
  border-radius: 3px;
  z-index: 999999;
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
}

.spinner-grow {
  width: 3rem;
  height: 3rem;
}
</style>
